<div class="toolbar flex-row align-center g-space-sm">
  <cam-communication-conversation-attachments
    [attachments]="this.attachments()"
    (attachmentsChanged)="this.attachmentsChanged.emit($event)"
  ></cam-communication-conversation-attachments>

  <cam-button-tool
    [actions]="this.toolActions()"
    [size]="'sm'"
    (actionSelected)="this.onActionSelected($event)"
  ></cam-button-tool>

  <cam-conversations-ai-tools
    [taskId]="this.taskId()"
    [message]="this.message()"
    [responseToCommunicationId]="this.responseToCommunicationId()"
    (generatedMessage)="this.generatedMessage.emit($event)"
    (changedType)="this.changedType.emit($event)"
  ></cam-conversations-ai-tools>
</div>
